import React, { useCallback } from "react"
import { useRouter } from "next/router"

import { Button } from "@coval/ui"

import { useQueryParams } from "@/hooks/useQueryParams"

interface AddWidgetButtonProps {
  dashboardId: string
  organizationSlug: string
}

export const AddWidgetButton: React.FC<AddWidgetButtonProps> = ({
  dashboardId,
  organizationSlug,
}) => {
  const router = useRouter()
  const queryParams = useQueryParams()

  const handleAddWidget = useCallback(() => {
    void router.push(
      queryParams.getHref(
        `/${organizationSlug}/dashboard/${dashboardId}/widgets/configure/new`,
      ),
    )
  }, [router, queryParams, organizationSlug, dashboardId])

  return (
    <Button
      variant="default"
      onClick={handleAddWidget}
      aria-label="New Widget"
      data-testid="dashboard-add-widget-button"
    >
      New Widget
    </Button>
  )
}
